"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlertSaveOrUpdateHandler = void 0;
// (C) 2021 GoodData Corporation
var react_1 = require("react");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var internal_1 = require("../../../hooks/internal");
var contexts_1 = require("../../../contexts");
function useAlertSaveOrUpdateHandler(_a) {
    var closeAlertDialog = _a.closeAlertDialog, backend = _a.backend, workspace = _a.workspace;
    var _b = contexts_1.useAlerts(), addAlert = _b.addAlert, updateAlert = _b.updateAlert;
    var _c = react_1.useState(), alertToSave = _c[0], setAlertToSave = _c[1];
    var saveOrUpdateAlert = function (alert) { return setAlertToSave(alert); };
    var _d = react_1.useState("idle"), alertSavingStatus = _d[0], setAlertSavingStatus = _d[1];
    internal_1.useSaveOrUpdateWidgetAlert({
        backend: backend,
        workspace: workspace,
        widgetAlert: alertToSave,
        onError: function () {
            setAlertSavingStatus("error");
            setAlertToSave(undefined);
        },
        onLoading: function () { return setAlertSavingStatus("inProgress"); },
        onSuccess: function (saved) {
            setAlertSavingStatus("idle");
            var wasUpdate = sdk_backend_spi_1.isWidgetAlert(alertToSave);
            if (wasUpdate) {
                updateAlert(saved);
            }
            else {
                addAlert(saved);
            }
            setAlertToSave(undefined);
            closeAlertDialog();
        },
    });
    return {
        alertSavingStatus: alertSavingStatus,
        saveOrUpdateAlert: saveOrUpdateAlert,
    };
}
exports.useAlertSaveOrUpdateHandler = useAlertSaveOrUpdateHandler;
//# sourceMappingURL=useAlertSaveOrUpdateHandler.js.map